import { ReactElement } from "react";
import { CellComponentProps } from "react-window";

import { RidesCalendarBodyCell } from "./rides-calendar.body-cell";
import { RidesCalendarCornerCell } from "./rides-calendar.corner-cell";
import { RidesCalendarHeadDateCell } from "./rides-calendar.head-date";
import { RidesCalendarHourLabelCell } from "./rides-calendar.hour-label";
import { IRidesCalendarGridData } from "./rides-calendar.models";

export const RidesCalendarCellRenderStrategy = ({
  style,
  rowIndex,
  columnIndex,
  data,
}: CellComponentProps<IRidesCalendarGridData> & {
  data: IRidesCalendarGridData;
}): ReactElement => {
  const { dateKeys, eventMap, visibleHourIndices, onOpenRide, onAddRide } =
    data;

  if (rowIndex === 0 && columnIndex === 0) {
    return <RidesCalendarCornerCell style={style} eventMap={eventMap} />;
  }
  if (rowIndex === 0) {
    return (
      <RidesCalendarHeadDateCell
        style={style}
        columnIndex={columnIndex - 1}
        dateKeys={dateKeys}
        eventMap={eventMap}
      />
    );
  }

  if (rowIndex > visibleHourIndices.length) {
    return <div style={style} aria-hidden="true" />;
  }

  const hourIndex = visibleHourIndices[rowIndex - 1];

  if (columnIndex === 0) {
    return (
      <RidesCalendarHourLabelCell
        style={style}
        hourIndex={hourIndex}
        eventMap={eventMap}
      />
    );
  }
  return (
    <RidesCalendarBodyCell
      style={style}
      dateKey={dateKeys[columnIndex - 1]}
      hourIndex={hourIndex}
      eventMap={eventMap}
      onOpenRide={onOpenRide}
      onAddRide={onAddRide}
    />
  );
};
